export const wrapperStyles = {};

export const poaSectionStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  maxWidth: '400px',
};

export const hintStyles = {
  marginTop: '8px',
};
